import { Component, Input, input, OnInit } from '@angular/core';

import { DynamicModule } from 'ng-dynamic-component';

import { MasonryComponent } from '@valk-nx/compositions/ui-masonry/src/lib/masonry.component';
import { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';
import { SectionBgClass } from '@valk-nx/core/lib/pipes/section-class/section-class.pipe';
import { BackgroundColors } from '@valk-nx/core/lib/pipes/section-class/section-class.types';
import { AnchorComponent } from '@valk-nx/storyblok/components/anchor/src/lib/anchor';
import { ColumnsComponent } from '@valk-nx/storyblok/components/columns/src/lib/columns';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { StoryblokHelper } from '@valk-nx/storyblok-helpers/src/lib/general/storyblok.helper';
import {
	Button,
	ISbStoryBlok,
	StoryblokImage,
} from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-masonry-section',
	templateUrl: './masonry-section.html',
	imports: [
		AnchorComponent,
		ColumnsComponent,
		DynamicModule,
		MasonryComponent,
		SectionBgClass,
		StoryblokDirective,
	],
})
export class StoryblokMasonryComponent
	extends StoryblokRootDirective
	implements OnInit
{
	@Input({ required: true }) title!: ISbStoryBlok[];
	@Input({ required: true }) images!: StoryblokImage[];
	@Input() button: Button[];
	sectionBackgroundClass = input<BackgroundColors>('gradient-80px');

	vpImages: PhotoInterface[] = [];
	titleWithFigures: ISbStoryBlok[] = [];

	ngOnInit(): void {
		this.setImages();
		this.setFigures();
	}

	setImages(): void {
		this.vpImages = this.images.map((image) => {
			if (image.bynder?.length > 0) {
				return StoryblokHelper.mapBynderToPhotoInterface(
					image.bynder[0],
				);
			} else {
				return {
					src: '',
				};
			}
		});
	}

	setFigures(): void {
		this.titleWithFigures = this.title.map((title) => {
			return {
				...title,
				topFigure: 'assets/icons/figure-line.svg',
			};
		});
	}
}
